import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { LicenseeAgreementService } from '../../program/program/components/program-licensee-agrement-list/licensee-agreement.service';
import { SharedModule } from 'src/app/core/shared/shared.module';
import { ViewPdfComponent } from '../../master-data/program-config/components/view-pdf/view-pdf.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { OrderService } from '../../social/order/service/order.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'vex-payment-success',
  standalone: true,
  template: `
    <div class="min-h-screen flex flex-col justify-center items-center">
      <img
        class="w-full max-w-lg  mb-6"
        src="assets/img/illustrations/paymentSuccess.svg" />

      <div
        class="w-full flex flex-row  justify-center items-center mb-5"
        *ngIf="pdfInvoiceData">
        <div class="flex flex-row gap-4 items-center">
          <button mat-flat-button type="button" (click)="viewFileData()">
            <span>View Invoice</span>
            <mat-icon
              iconPositionStart
              matButtonIcon
              svgIcon="mat:remove_red_eye"></mat-icon>
          </button>

          <button mat-flat-button type="button" (click)="onDownload()">
            <span>Download Invoice</span>
            <mat-icon
              iconPositionStart
              matButtonIcon
              svgIcon="mat:arrow_downward"></mat-icon>
          </button>
        </div>
      </div>

      <button mat-flat-button color="primary" routerLink="/home">
        Go to Dashboard
      </button>
    </div>
  `,
  imports: [RouterLink, MatButtonModule, MatIconModule, CommonModule]
})
export class PaymentSuccessComponent {
  pdfInvoiceData: any;
  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private orderService: OrderService
  ) {}
  ngOnInit() {
    let id = this.route.snapshot.queryParams['uuid'];
    this.getOrderDetails(id);
    // this.LicenseeAgreementService.getLicenseeAgreementById(id).subscribe(
    //   (resp) => {
    //     this.pdfInvoiceData = resp.pdfInvoice;
    //   }
    // );
  }

  viewFileData() {
    let dialogRef: MatDialogRef<ViewPdfComponent>;
    dialogRef = this.dialog.open(ViewPdfComponent, {
      width: '80%',
      data: {
        src: this.pdfInvoiceData,
        title: 'Invoice'
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {});
  }

  onDownload() {
    const fileUrl = this.pdfInvoiceData;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'filename'; // You can set the desired filename here
    document.body.appendChild(link);

    // Trigger a click on the link to start the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);
  }

  async getOrderDetails(id: string) {
    try {
      let orderResp = await firstValueFrom(
        this.orderService.getOrderByUUID(id)
      );
      if (orderResp) {
        this.pdfInvoiceData = orderResp?.invoiceForm;
      }
    } catch (err) {
      console.log('err :>> ', err);
    }
  }
}
